import * as React from 'react';
import { useState } from "react";
import {
  Card
} from 'one-ui-card/src/card';
import Table from "antd/lib/table";
import Dropdown from "antd/lib/dropdown";
import Button from "antd/lib/button";
import Menu from "antd/lib/menu";
import Tag from "antd/lib/tag";
import Modal from "antd/lib/modal";
import Divider from "antd/lib/divider";

import {
  OrdersModel
} from './model';

import {
  OrdersCardProps
} from './props';

/**
 * This function returns the Order Tab
 * @param props is a component property
 * @returns JSX code for Order Tab Card
 */
export const OrderTabCard = <M extends OrdersModel>(
  props: OrdersCardProps<M>
) => {
  const {
    model,
  } = props;

  const {
    orderdata
  } = model || {};

  let tabledata: any = [];
  let modalUI = <></>
  const [moredetmodel, setMoredetmodel] = useState(false);
  const [moredetails, setMoredetails] = useState({});

  const menu = (e: any) => (

    <Menu onClick={handleMenuClick}>
      <Menu.Item key={e.key + ",1"}>More Details</Menu.Item>
    </Menu>
  );

  const columns = [
    {
      title: () => (<span style={{ paddingLeft: "1.1rem" }}>Created</span>),
      dataIndex: 'created',
      key: 'created',
    },
    {
      title: 'Request ID',
      dataIndex: 'requestid',
      key: 'requestid',
    },
    {
      title: 'Procedure Name',
      dataIndex: 'procedurename',
      key: 'procedurename',
    },
    {
      title: 'Requesting Provider',
      dataIndex: 'requestingprovider',
      key: 'requestingprovider',
    },
    {
      title: 'Creation Department',
      dataIndex: 'creationdepartment',
      key: 'creationdepartment',
    },
    {
      dataIndex: 'tag',
      key: 's5',
      render: (data: any) => {
        return (
          <Tag color={data.type} className="ant-tag--rounded" style={{ minWidth: "60px" }}>
            {data.name}
          </Tag>
        )
      }
    },
    {
      title: "Action",
      key: "action",
      render: (text: any, record: any) => (
        <Dropdown overlay={menu(record)}>
          <Button type="link" size="small" className="ant-btn-link--dark">&hellip;</Button>
        </Dropdown>
      )
    }
  ];
  if (orderdata?.length > 0) {
    orderdata.forEach((infodata: any) => {
      tabledata.push(infodata);
    })
  }

  const handleMenuClick = (e: any) => {
    let key = e.key;
    let res = key.split(",");
    if (res[1] === '1') {
      setMoredetmodel(true);
      orderdata.forEach((rec: any, index: any) => {
        if (res[0] === rec?.key?.toString()) {
          setMoredetails(rec);
        }
      });
    }
  }

  const handleOk = (e: any) => {
    setMoredetmodel(false);
  };

  const handleCancel = (e: any) => {
    setMoredetmodel(false);
  };
  modalUI = (
    <>
      <Table
        className="ant-table--smaller"
        columns={columns}
        dataSource={tabledata}
        pagination={false}
      />
      <Modal
        visible={moredetmodel}
        closable={false}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <div className="box" style={{ width: "460px" }}>
          <div className="text-2xl text-center text-black-85 font-medium mb-10">Order Details – {moredetails != undefined ? moredetails.requestid : ""}</div>
          <div className="flex justify-between text-sm text-black-85 mb-20">
            <div><span className="text-black-40">Order Created:</span>  {moredetails != undefined ? moredetails.created : ""}</div>
            <div><span className="text-black-40">Request ID:</span>  {moredetails != undefined ? moredetails.requestid : ""}</div>
          </div>
          <Divider style={{ margin: "1rem 0" }} />
          <div className="text-sm text-black-85">
            <div className="mb-5"><span className="text-black-40">Procedure Name:</span> {moredetails != undefined ? moredetails.procedurename : ""}</div>
            <div className="mb-5"><span className="text-black-40">Patient Preferred language:</span> {moredetails != undefined ? moredetails.patientpreferredlanguage : ""}</div>
            <div className="mb-5"><span className="text-black-40">Visit Dept IDs:</span> {moredetails != undefined ? moredetails.visitdeptid : ""}</div>
            <div className="mb-5"><span className="text-black-40">Visit Type IDs:</span> {moredetails != undefined ? moredetails.visittypeid : ""}</div>
            <div className="mb-5"><span className="text-black-40">Speciality ID:</span> {moredetails != undefined ? moredetails.specialityid : ""}</div>
            <div className="mb-5"><span className="text-black-40">Requesting Provider:</span> {moredetails != undefined ? moredetails.requestingprovider : ""}</div>
            <div className="mb-5"><span className="text-black-40">Creation Department:</span> {moredetails != undefined ? moredetails.creationdepartment : ""}</div>
            <div className="mb-5"><span className="text-black-40">TCH C_Current WQs Tab:</span> {moredetails != undefined ? moredetails?.tag?.name : ""}</div>
          </div>
          <Divider style={{ margin: "1rem 0" }} />
        </div>
      </Modal>
    </>
  )

  return (
    <Card
      title={""}
      body={modalUI}
    />
  )
}
